import { GET_INVOICE } from './getInvoice';
import { UPDATE_INVOICE } from './updateInvoice';

export const invoiceApi = {
  update: UPDATE_INVOICE,
  getByID: GET_INVOICE,
};
